import { isStringEmpty } from "@/common/validation-checkers";

interface IProps {
    value?: number;
    purpose: string;
    newValue: (val: string | number | undefined) => void;
}

const NumberComponent: React.FC<IProps> = ({value, purpose, newValue}) => {

    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            <input 
                className="text-black px-2 py-1 block w-full"
                type="number" 
                id={purpose}
                value={value || ""} 
                onChange={(event) => isStringEmpty(event.target.value) ? newValue(undefined) : newValue(event.target.value)} 
            />
        </div>
    )
}

export default NumberComponent;